export const accessibilityInstructions = "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year.";
export const navigationInstructions = "Tab into the calendar.";
